// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MfEzO","buttons":"styles_buttons__286Rn"};